<div class="notification-content" [class.context-warning]="isDangerContext">
    <span class="left-icon"></span>
    <div class="message">{{ message }}</div>
    <a href="javascript:" class="close-icon sp-close-icon" (click)="dismiss($event)"></a>
</div>
